import React from 'react'
import { Link } from 'react-router-dom'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@shared/components/ui/dropdown-menu'
import ThemeToggle from '@shared/components/ThemeToggle'
import { Button } from '@shared/components/ui/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faUserShield, faCog } from '@fortawesome/free-solid-svg-icons'
import { useAdminAuth } from '@/contexts/AdminAuthContext'

const AdminNavbar: React.FC = () => {
  const { adminUser, logout } = useAdminAuth()

  return (
    <div className="sticky top-0 w-full h-16 bg-background border-b border-border flex items-center justify-between px-4 z-20">
      {/* Mobile: Position Motiv Admin text to the right of menu button */}
      <div className="md:hidden ml-16">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <h1 className="text-xl font-bold text-primary-600">Motiv Admin</h1>
          </div>
        </div>
      </div>

      {/* Desktop: Normal positioning */}
      <div className="hidden md:block">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-primary-600">Motiv Admin</h1>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4">

        <ThemeToggle />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-3 rounded-full px-2 py-1 hover:bg-accent">
              <div className="flex items-center justify-center h-8 w-8 rounded-full bg-primary text-primary-foreground">
                <FontAwesomeIcon icon={faUserShield} className="h-4 w-4" />
              </div>
              <div className="hidden sm:block text-sm text-left">
                <div className="font-medium leading-none text-foreground">
                  {adminUser?.display_name || adminUser?.email || 'Admin'}
                </div>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56 bg-popover text-popover-foreground border border-border shadow-md">
            <DropdownMenuItem asChild>
              <Link to="/admin/account-settings">
                <FontAwesomeIcon icon={faCog} className="mr-2 h-4 w-4" />
                Account Settings
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout} className="text-red-500">
              <FontAwesomeIcon icon={faSignOutAlt} className="mr-2 h-4 w-4" />
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  )
}

export default AdminNavbar
